import { Checkbox } from "shared/components";
import { type RegisterTyped } from "shared/hooks/use-form-typed";

interface Props {
  label: string;
  field?: ReturnType<RegisterTyped<Record<string, string | boolean>>>;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const BoolCheckbox = ({ field, label, checked, onChange }: Props) => (
  <Checkbox
    name={field?.name ?? ""}
    checked={field ? field.value === true : Boolean(checked)}
    onChange={(e) => {
      if (field) field.onChange(e.target.checked);
      else onChange?.(e.target.checked);
    }}
    label={label}
  />
);
